import { formatMessage } from "lib/globalize-util";
import { DimensionsPanelReduxState } from "reducers/dimensions-panel/dimensions-panel";
import { generateMetricsActiveList, generateWeightByKindOfMetric, isColumnUnderThreshold } from "./utils";

export const useThresholdWarningMessage = (
    draftState: DimensionsPanelReduxState,
    errorMessage: string | undefined
): string | undefined => {
    if (errorMessage || !draftState.showDoors) {
        return;
    }
    const selectedAttributes = draftState.attributes.filter((attribute) => attribute.selected);

    const selectedDeliveriesCount = draftState.dimensions[0].values.reduce(
        (acc, value) => (value.selected ? acc + 1 : acc),
        0
    );

    const doorsDimension = draftState.dimensions[1];
    const isDimensionDoorSelected = doorsDimension.selected;

    const selectedDoorsCount = !isDimensionDoorSelected
        ? 0
        : doorsDimension.values.reduce((acc, value) => (value.selected ? acc + 1 : 0), 0);

    const metricsKindActivated = generateMetricsActiveList(draftState.metrics.values);

    const weightOfMetricsSelected = generateWeightByKindOfMetric(metricsKindActivated);

    return isColumnUnderThreshold(
        selectedDeliveriesCount,
        selectedDoorsCount,
        selectedAttributes,
        weightOfMetricsSelected
    )
        ? undefined
        : formatMessage("The number of selections may cause poor performance");
};
